"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var email_before_freebie_1 = require("../../bundler/components/email-before-freebie");
var horizontal_drag_scroll_1 = __importDefault(require("../../shared-components/horizontal-drag-scroll"));
var variant_details_modal_1 = __importDefault(require("../components/variant-details-modal"));
var bundle_1 = require("../store/bundle");
var scrolling_1 = require("../utils/scrolling");
var ProductCard = function (_a) {
    var _b;
    var item = _a.item, selected = _a.selected, onClick = _a.onClick, className = _a.className, imageContainerClassName = _a.imageContainerClassName, onClickMagnifier = _a.onClickMagnifier, width = _a.width;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('position-relative', className), style: { width: width, userSelect: 'none', paddingTop: 5, paddingRight: 5 } },
        react_1.default.createElement("a", { className: 'position-absolute top-0 right-0', style: { height: 30, width: 30 }, onClick: onClickMagnifier },
            react_1.default.createElement("i", { className: 'ss-zoomin bundler-v2-patterns--zoomin-icon position-absolute circle text-wisteria border-wisteria text-lg width-100 height-100 bg-white flex-container align-center align-middle', style: { borderStyle: 'solid', borderWidth: 1 } })),
        react_1.default.createElement("div", { className: 'height-100', style: { display: 'grid', gridTemplateRows: 'min-content auto', gridTemplateColumns: '1fr' }, onClick: onClick },
            react_1.default.createElement("div", { className: (0, classnames_1.default)(imageContainerClassName, 'rounded-lg overflow-hidden', selected ? 'border-wisteria' : 'border-brownish-grey'), style: { gridArea: '1 / 1 / 2 / 2', height: width, aspectRatio: width ? undefined : '1/1', borderWidth: selected ? 3 : 1, borderStyle: 'solid' } }, ((_b = item.variant.featuredImage) === null || _b === void 0 ? void 0 : _b.src) && (react_1.default.createElement("img", { className: 'height-100 width-100 object-fit-cover', src: item.variant.featuredImage.src, alt: item.variant.featuredImage.alt, draggable: false, style: { pointerEvents: 'none', userSelect: 'none' } }))),
            react_1.default.createElement("div", { className: 'flex-container flex-dir-column align-justify height-100', style: { gridArea: '2 / 1 / 3 / 2' } },
                react_1.default.createElement("div", { className: 'h-1' }),
                react_1.default.createElement("div", { className: 'text-sm' }, item.product.title),
                react_1.default.createElement("div", { className: 'text-sm' },
                    react_1.default.createElement("span", { className: 'strike text-gray' },
                        "$",
                        item.variant.compareAtPrice),
                    "\u00A0\u00A0$",
                    item.variant.price)))));
};
/** select this addon */
var onOptionClick = function (addon, changeAddons) {
    // since only one freebie is allowed, we simply replace the current freebie with this one
    changeAddons([{ variant: addon.variant, product: addon.product, quantity: 1 }]);
};
var FreebieAddons = function (_a) {
    var navBar = _a.navBar, emailBeforeFreebie = _a.emailBeforeFreebie;
    var useBundleStore = (0, bundle_1.getBundleStore)().useBundleStore;
    var buildAvailableFreebieAddonGroups = useBundleStore(function (state) { return state.buildAvailableFreebieAddonGroups; });
    var selectedFreebieAddons = useBundleStore(function (state) { return state.selectedFreebieAddons; });
    var changeSelectedFreebieAddons = useBundleStore(function (state) { return state.changeSelectedFreebieAddons; });
    var products = useBundleStore(function (state) { return state.products; });
    var selPatterns = useBundleStore(function (state) { return state.selectedPatterns; });
    var _b = __read((0, react_1.useState)(undefined), 2), openModalItem = _b[0], setOpenModalItem = _b[1];
    var handleSetOpenModalVariant = function (variant) {
        var shopifyProduct = products === null || products === void 0 ? void 0 : products.find(function (p) { return p.variants.some(function (v) { return v.id === variant.id; }); });
        if (shopifyProduct)
            setOpenModalItem({ product: shopifyProduct, variant: variant });
    };
    // Instantly scroll to top. This is necessary because we share the page's scrollbar between all of the steps
    // and we want the user to start at the top of each step.
    var hasPerformedInitialScrollToTop = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        if (!hasPerformedInitialScrollToTop.current) {
            (0, scrolling_1.performInstantScroll)(window, { top: 0 });
            hasPerformedInitialScrollToTop.current = true;
        }
    });
    var hasEmittedDataLayerEvent = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        var _a;
        if (!hasEmittedDataLayerEvent.current) {
            // TODO: report pattern quantity here since we couldn't report it yet when the user arrived at the discounts step?
            (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ event: 'diaperBundle__selectFreebies' });
            hasEmittedDataLayerEvent.current = true;
        }
    });
    var displayGroups = (0, react_1.useMemo)(function () {
        return buildAvailableFreebieAddonGroups() || [];
    }, [buildAvailableFreebieAddonGroups]);
    var selectedFreebiesQuantity = selectedFreebieAddons.reduce(function (total, addon) { return total + addon.quantity; }, 0);
    // allow users to bypass freebie collection by enabling the next button, but then re-lock the next button once we've collected their
    // email to force them to take advantage of the freebie they've earned
    var nextButtonEnabled = selectedFreebiesQuantity >= bundle_1.MIN_FREEBIE_ADDONS || emailBeforeFreebie.enabled;
    var productCardWidth = 128;
    // used to build out bundleProperties to send to klaviyo
    var bundleInfoForEmailCollectionEvent = (0, react_1.useMemo)(function () {
        var patternConfigs = (function (patterns) {
            return patterns.map(function (selectedPattern) {
                switch (selectedPattern.size) {
                    case 'diaper_n':
                        return { sizes: ['N'], bundleType: 'Diapers' };
                    case 'diaper_1':
                        return { sizes: ['1'], bundleType: 'Diapers' };
                    case 'diaper_2':
                        return { sizes: ['2'], bundleType: 'Diapers' };
                    case 'diaper_3':
                        return { sizes: ['3'], bundleType: 'Diapers' };
                    case 'diaper_4':
                        return { sizes: ['4'], bundleType: 'Diapers' };
                    case 'diaper_5':
                        return { sizes: ['5'], bundleType: 'Diapers' };
                    case 'diaper_6':
                        return { sizes: ['6'], bundleType: 'Diapers' };
                    case 'training_12_24':
                        return { sizes: ['12-24M'], bundleType: 'TrainingPants' };
                    case 'training_2t_3t':
                        return { sizes: ['2T-3T'], bundleType: 'TrainingPants' };
                    case 'training_3t_4t':
                        return { sizes: ['3T-4T'], bundleType: 'TrainingPants' };
                    case 'training_4t_5t':
                        return { sizes: ['4T-5T'], bundleType: 'TrainingPants' };
                    case 'mixed_12_24':
                        return { sizes: ['12-24M'], bundleType: 'Mixed' };
                    case 'mixed_2t_3t':
                        return { sizes: ['2T-3T'], bundleType: 'Mixed' };
                    case 'mixed_3t_4t':
                        return { sizes: ['3T-4T'], bundleType: 'Mixed' };
                    case 'mixed_4t_5t':
                        return { sizes: ['4T-5T'], bundleType: 'Mixed' };
                }
            });
        })(selPatterns);
        var bundleSizes = patternConfigs.map(function (config) { return config.sizes[0]; });
        var bundleTypes = patternConfigs.map(function (config) { return config.bundleType; });
        return {
            event: 'diaperBundle__emailB4FreebieCollected',
            bundleSettings: {
                sizes: __spreadArray([], __read(new Set(bundleSizes)), false),
                bundleType: __spreadArray([], __read(new Set(bundleTypes)), false).length > 1 ? 'Mixed' : bundleTypes[0],
            },
        };
    }, [selPatterns]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        emailBeforeFreebie.enabled && !emailBeforeFreebie.collectedEmail ? (react_1.default.createElement(email_before_freebie_1.EmailBeforeFreebie, { setCollectedEmail: emailBeforeFreebie.setCollectedEmail, onSubmitGaEventName: bundleInfoForEmailCollectionEvent.event, bundleProperties: bundleInfoForEmailCollectionEvent.bundleSettings })) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: 'h-8' }),
            react_1.default.createElement("div", { className: 'padding-horizontal-6 space-y-2' },
                react_1.default.createElement("div", { className: 'flex-container align-justify' },
                    react_1.default.createElement("div", { className: 'text-2xl', style: { fontWeight: 600 } }, "Pick Your Freebie")),
                react_1.default.createElement("div", { className: 'flex-container align-justify' },
                    react_1.default.createElement("div", { className: 'text-almost-black' }, "Pick a free product to make your first shipment extra awesome."))),
            react_1.default.createElement("div", { className: 'h-4' }),
            react_1.default.createElement("div", { className: 'margin-horizontal-6 border-very-light-pink', style: { borderTopWidth: 1, borderTopStyle: 'solid' } }),
            react_1.default.createElement("div", { className: 'h-4' }),
            react_1.default.createElement("div", { className: 'padding-left-6' },
                react_1.default.createElement("div", { className: 'space-y-4' }, displayGroups.map(function (group) { return (react_1.default.createElement("div", { key: group.displayName },
                    react_1.default.createElement("div", { className: 'text-xl' }, group.displayName),
                    react_1.default.createElement("div", { className: 'h-2' }),
                    group.displayType === 'horizontalScroll' ? (react_1.default.createElement(horizontal_drag_scroll_1.default, { className: 'horizontal-drag-scroll--container padding-right-6 space-x-4 hide-scrollbar cursor-grab-grabbing' }, group.items.map(function (item) {
                        var addon = selectedFreebieAddons.find(function (p) { return p.variant.id === item.variant.id; });
                        return (react_1.default.createElement(ProductCard, { key: "".concat(item.variant.id, "-").concat(item.product.selectedSku), className: 'horizontal-drag-scroll--item', width: productCardWidth, item: item, selected: !!addon, onClick: function () { return onOptionClick(item, changeSelectedFreebieAddons); }, onClickMagnifier: function () { return handleSetOpenModalVariant(item.variant); } }));
                    }))) : (react_1.default.createElement("div", { className: 'bundler-v2-index--product-card-grid padding-right-6' }, group.items.map(function (item) {
                        var addon = selectedFreebieAddons.find(function (p) { return p.variant.id === item.variant.id; });
                        return (
                        // Here we avoid providing a fixed width so that the product card can expand to fill the available grid space.
                        // Note that this makes the grid items a different size from the horizontal scroll items at most window widths.
                        react_1.default.createElement(ProductCard, { key: "".concat(item.variant.id, "-").concat(item.product.selectedSku), imageContainerClassName: 'cursor-pointer', item: item, selected: !!addon, onClick: function () { return onOptionClick(item, changeSelectedFreebieAddons); }, onClickMagnifier: function () { return handleSetOpenModalVariant(item.variant); } }));
                    }))))); }))),
            openModalItem && (react_1.default.createElement(variant_details_modal_1.default, { item: openModalItem, handleCloseModalClick: function () { return setOpenModalItem(undefined); }, isDiscount: false, handleIncreaseClick: function () {
                    var addon = (function () {
                        var e_1, _a, e_2, _b;
                        try {
                            for (var displayGroups_1 = __values(displayGroups), displayGroups_1_1 = displayGroups_1.next(); !displayGroups_1_1.done; displayGroups_1_1 = displayGroups_1.next()) {
                                var group = displayGroups_1_1.value;
                                try {
                                    for (var _c = (e_2 = void 0, __values(group.items)), _d = _c.next(); !_d.done; _d = _c.next()) {
                                        var item = _d.value;
                                        if (item.variant.id === openModalItem.variant.id)
                                            return item;
                                    }
                                }
                                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                finally {
                                    try {
                                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                                    }
                                    finally { if (e_2) throw e_2.error; }
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (displayGroups_1_1 && !displayGroups_1_1.done && (_a = displayGroups_1.return)) _a.call(displayGroups_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        throw new Error('Encountered coding bug while trying to look up addon');
                    })();
                    onOptionClick(addon, changeSelectedFreebieAddons);
                } })))),
        navBar({ backButtonEnabled: true, nextButtonEnabled: nextButtonEnabled })));
};
exports.default = FreebieAddons;
